export const SUB_ITEMS_FIELD = 'assignedLots';
export const EXPAND_FIELD = 'expanded';
export const DATA_ITEM_KEY = 'id';
export const ADD_FIELD = 'isNew';
export const MODE_FIELD = '_mode';
export const IS_LOT_ADDITION = 'isLotAddition';
export const FIELDS_TO_OMIT = [MODE_FIELD, ADD_FIELD, IS_LOT_ADDITION, EXPAND_FIELD, 'parentPartId', 'parentId', 'isLotAdditionIconsShown', 'selectedLotLabel', 'childrenLotIds'];
export const LOT_FIELDS_TO_OMIT = [...FIELDS_TO_OMIT, 'quantityOnHand', 'isLotAdditionIconsShown', 'selectedLotLabel', 'childrenLotIds'];
export const EB_FIELDS_TO_OMIT = [...FIELDS_TO_OMIT, 'quantityOnHand', 'isLotAdditionIconsShown', 'selectedLotLabel', 'childrenLotIds'];
export const MAX_DECIMALS = 4;
export const CELL_EMPTY_VALUE = '-';
export const LHRS_START_QUANTITY_NAME = 'lhrs-start-quantity';
export const MIN_SEARCH_TERM_LENGTH = 3;
